





















import { Component, Vue, Watch } from 'vue-property-decorator'
import TopDetailInfo from './components/TopDetailInfo.vue'
import AdvAbility from './components/AdvAbility.vue'
import ProduceExp from './components/ProduceExp.vue'
import AccessProcess from './components/AccessProcess.vue'
import AppCase from './components/AppCase.vue'
import pubDetailJSON from './case-detail.json'
import PriDetailJSON from './pri-case-detail.json'
import FooterInfo from '@/apps/open/layout/FooterInfo.vue'

@Component({
  components: {
    TopDetailInfo,
    AdvAbility,
    ProduceExp,
    AccessProcess,
    AppCase,
    FooterInfo
  }
})

export default class CaseDetail extends Vue {
  get caseId (): string {
    return this.$route.query.id as string
  }
  get detailData (): object | void {
    const DetailJSON = this.isPrivate ? PriDetailJSON : pubDetailJSON
    if (DetailJSON.hasOwnProperty(this.caseId)) {
      return (DetailJSON as any)[this.caseId]
    } else {
      this.$router.replace({ name: 'home' })
    }
  }
  get isPrivate () {
    return this.$store.getters['isPrivate']
  }
}
